// extracted by mini-css-extract-plugin
export default {"dataGridCell":"datagrid_dataGridCell__NI2Mt"};